export default __webpack_public_path__ + "static/media/web-allina-icon-03.6fb433ed.svg";